export const config = {
  urlFont:
    process.env.NODE_ENV === 'production'
      ? 'https://az.genially.com/users/#idUser/custom/#font.ttf'
      : 'https://geniallydev.blob.core.windows.net/geniallydev/users/#idUser/custom/#font.ttf',
  urlFontTeam:
    'https://genially-fonts.s3.eu-west-1.amazonaws.com/teams/#teamId/custom/#font.ttf',
};
